import * as React from "react";
import { useTranslation } from "react-i18next";
import { create, keyResolver, windowScheduler } from "@yornaath/batshit";
import { useQuery } from "@tanstack/react-query";
import { EventsDefinitions } from "@graylog/server-api";
import Spinner from "components/common/Spinner";
const fetchEventDefinition = create({
  fetcher: async (ids) => EventsDefinitions.getById({ event_definition_ids: ids }),
  resolver: keyResolver("id"),
  scheduler: windowScheduler(10)
});
const EventDefinition = ({ value }) => {
  const { t } = useTranslation("widgets");
  const { data: eventDefinition, isLoading } = useQuery({
    queryKey: ["event-definitions", "batched", value],
    queryFn: () => fetchEventDefinition.fetch(value)
  });
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return (eventDefinition == null ? void 0 : eventDefinition.title) ? /* @__PURE__ */ React.createElement("span", null, eventDefinition.title) : /* @__PURE__ */ React.createElement("i", null, t("field_types.missing_event_definition", { id: value }));
};
export default EventDefinition;
